import React from "react";
import styled from "styled-components";
import { useMobile } from "../Responsive";

const Wrapper = styled.div<{ mobile?: boolean }>`
  display: flex;
  padding-left: 9px;
  padding-right: 9px;
  align-items: center;
  font-size: 22px;
  width: ${({ mobile }) => (mobile ? "14px" : "96px")};
  height: 29px;
  cursor: pointer;
  background: #ffffff;
  margin-bottom: 2px;
  color: #c41230;
`;

function ToolbarItem({
                       Icon,
                       onClick,
                       label,
                       AfterIcon,
                       labelSpacing,
                     }: IToolbarItem) {
  const mobile = useMobile();

  return (
    <Wrapper mobile={mobile} onClick={onClick ? onClick : undefined}>
      {Icon}{" "}
      {!mobile && (
        <>
          <div
            style={{
              fontSize: "12px",
              margin: labelSpacing ? "auto" : "0px 0px 0px 9px",
              opacity: 0.6,
              color: "black",
            }}
          >
            {label}
          </div>{" "}
        </>
      )}
      {AfterIcon}
    </Wrapper>
  );
}

export interface IToolbarItem {
  Icon: React.ReactChild;
  AfterIcon?: React.ReactChild;
  onClick?: () => void;
  labelSpacing?: boolean;
  label: React.ReactText;
}

export default ToolbarItem;
